// extracted by mini-css-extract-plugin
export var createdDate = "_j6-1";
export var divider = "_j6-2";
export var headerDivider = "_j6-3";
export var messagesCard = "_j6-0";
export var messagesContainer = "_j6-6";
export var messagesContainerWrapper = "_j6-4";
export var showLeftPanelButton = "_j6-8";
export var topButtons = "_j6-7";
export var withPadding = "_j6-5";